import { render, staticRenderFns } from "./assignments.vue?vue&type=template&id=10ba0153&scoped=true"
import script from "./assignments.vue?vue&type=script&lang=js"
export * from "./assignments.vue?vue&type=script&lang=js"
import style0 from "./assignments.vue?vue&type=style&index=0&id=10ba0153&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ba0153",
  null
  
)

export default component.exports